<template>
  <div class="videoBox">
    <el-dialog
      :visible.sync="dialogFormVisible"
      :showClose="showClose"
      :close-on-click-modal="showClose"
      :close-on-press-escape="showClose"
    >
      <div @click="handleClose" class="closeBtn">
        <i class="el-icon-close"></i>
      </div>
      <div class="videoCont">
        <div class="videoBox" ref="videoBox" :style="{'min-height': videoHet + 'px'}">
          <!-- <video
            :src="videos"
            autoplay="autoplay"
            :poster="videoImg"
            controls="controls"
            class="divVideo"
            id="video2"
          >
            您的浏览器不支持 video 标签。
          </video> -->
          <d-player v-if="play" :key="actInd" ref="player" id="player" :options="options"></d-player>
        </div>
        <div class="playList" >
          <div class="title">播放列表</div>
          <div class="item" :class="{act: actInd == index}" v-for="(item, index) in playList" :key="index" @click="playVideo(item, index)">
            {{item.title}}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dPlayer from './dplayer'
import './dplayer/dist/vue-dplayer.css'
export default {
  name: "items",
  props: {},
  data() {
    return {
      dialogFormVisible: false,
      videoImg: "",
      videos: "",
      play: false,
      showClose: false,
      playList: [],
      actInd: 0,
      baseInfo:{
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: ''
      },
      videoHet: 80,
      options: {
          autoplay:true, //自动播放
          loop: true,
          lang: 'zh-cn',
          video: {
            url: '',
            pic: '',
          },
          contextmenu: [{}]
        },
    };
  },
  components:{
    dPlayer
  },
  methods: {
    // 弹层显示
    dialogFormV(data) {
      this.playList = data.slice(1,data.length + 1)
      this.dialogFormVisible = true;
      this.play = true;
      // this.videoImg = '';
      this.options.video.url = data[1].url || data[1].pVideoUrl
      this.options.video.pic = data.videologoImage
      // if (data[1].url !== undefined) {
      //   this.videos = data[1].url;
      // } else {
      //   this.videos = data[1].pVideoUrl;
      // }
    },
    playVideo(data, index){
      console.log(data)
      this.videoHet = this.$refs.videoBox.clientHeight
      this.actInd = index
      this.options.video.url = data.url
    },
    // 弹层隐藏
    dialogFormH() {
      this.play = false;
      this.dialogFormVisible = false;
    },

    // 退出
    handleClose() {
      // var myVideo = document.getElementById("video2");
      // myVideo.pause();
      this.play = false;
      this.dialogFormVisible = false;
    },
  },
  // 挂载结束
  mounted: function() {},
  // 创建完毕状态
  created() {},
  // 组件更新
  updated: function() {},
};
</script>
<style></style>
<style lang="scss">
.videoBox {
  .el-dialog__header,
  .el-dialog {
    background: transparent;
    box-shadow: none;
  }
  .el-icon-close {
    font-size: 30px;
    cursor: pointer;
  }
}
.el-dialog__body {
  height: 100%;
  padding: 0px !important;
  background: #000  !important;
  // width: 80%;
}
</style>
<style lang="scss">
.videoBox {
  .divVideo {
    // width: 100%;
    flex: 1;
    max-height: 850px;
  }
  .videoCont{
    display: flex;
    background: #000;
    .videoBox{
      flex: 1;
    }
    .playList{
      width: 200px;
      padding: 20px;
      background: #000;
      line-height: 32px;
      font-size: 12px;
      cursor: pointer;
      .title{
        color:rgba(255,255,255,0.8)
      }
      .item{
        color:rgba(255,255,255,0.8)
      }
      .item:hover{
        color: #1286FF;
      }
      .act{
        color:#1286FF;
      }
    }
  }
}
</style>
